'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import a$1 from "../defs/MagnifyingGlass.es.js";
const o = a.forwardRef((s, n) => /* @__PURE__ */ a.createElement(p, { ref: n, ...s, weights: a$1 }));
o.displayName = "MagnifyingGlassIcon";
const f = o;
export {
  f as MagnifyingGlass,
  o as MagnifyingGlassIcon
};
